// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard {
  max-width: 1200px;
}

.dashboard-loading {
  text-align: center;
  padding: 40px;
  color: #666;
}

.dashboard h2 {
  margin: 0 0 20px 0;
  color: #333;
  font-size: 24px;
}

.stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 20px;
  margin-bottom: 40px;
}

.dashboard-section {
  background: white;
  padding: 24px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  margin-bottom: 30px;
}

.dashboard-section h3 {
  margin: 0 0 20px 0;
  color: #333;
  font-size: 20px;
}

.period-selector {
  display: flex;
  gap: 10px;
  margin-bottom: 20px;
}

.period-selector button {
  padding: 8px 16px;
  border: 1px solid #ddd;
  background: white;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.2s;
}

.period-selector button:focus {
  outline: 2px solid #1976d2;
  outline-offset: 2px;
}

.period-selector button:hover {
  background: #f5f5f5;
}

.period-selector button.active {
  background: #1976d2;
  color: white;
  border-color: #1976d2;
}

.chart-container {
  min-height: 200px;
}

.growth-chart {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.growth-bar {
  display: flex;
  align-items: center;
  gap: 15px;
}

.bar-label {
  width: 100px;
  font-size: 12px;
  color: #666;
  text-align: right;
}

.bar-wrapper {
  flex: 1 1;
  height: 24px;
  background: #e0e0e0;
  border-radius: 12px;
  overflow: hidden;
}

.bar-fill {
  height: 100%;
  background: linear-gradient(90deg, #1976d2, #42a5f5);
  transition: width 0.3s ease;
}

.bar-value {
  width: 50px;
  font-size: 14px;
  font-weight: 600;
  color: #333;
  text-align: right;
}

.no-data {
  text-align: center;
  padding: 40px;
  color: #999;
}

.whatsapp-stats {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 20px;
}

.whatsapp-stat-item {
  text-align: center;
  padding: 20px;
  background: #f5f5f5;
  border-radius: 8px;
}

.whatsapp-stat-item .stat-label {
  font-size: 14px;
  color: #666;
  margin-bottom: 10px;
}

.stat-value-large {
  font-size: 36px;
  font-weight: 700;
  color: #1976d2;
}

.analytics-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 20px;
}

.analytics-card {
  background: #f5f5f5;
  padding: 20px;
  border-radius: 8px;
  text-align: center;
}

.analytics-label {
  font-size: 14px;
  color: #666;
  margin-bottom: 10px;
}

.analytics-value {
  font-size: 24px;
  font-weight: 700;
  color: #1976d2;
}

.realtime-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 20px;
}

.realtime-card {
  background: white;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  text-align: center;
}

.realtime-label {
  font-size: 14px;
  color: #666;
  margin-bottom: 10px;
}

.realtime-value {
  font-size: 32px;
  font-weight: 700;
  color: #1976d2;
  margin-bottom: 5px;
}

.realtime-value.healthy {
  color: #4caf50;
}

.realtime-value.degraded {
  color: #ff9800;
}

.realtime-subtitle {
  font-size: 12px;
  color: #999;
}

.message-volume-chart {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.message-volume-item {
  padding: 15px;
  background: #f5f5f5;
  border-radius: 8px;
}

.volume-label {
  font-size: 12px;
  color: #666;
  margin-bottom: 10px;
}

.volume-bars {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.volume-bar-wrapper {
  display: flex;
  align-items: center;
  gap: 10px;
}

.volume-bar-label {
  width: 80px;
  font-size: 12px;
  color: #666;
}

.volume-bar-container {
  flex: 1 1;
  display: flex;
  align-items: center;
  gap: 10px;
  height: 20px;
  position: relative;
}

.volume-bar {
  height: 100%;
  border-radius: 4px;
  transition: width 0.3s ease;
}

.volume-bar.sent {
  background: #1976d2;
}

.volume-bar.received {
  background: #42a5f5;
}

.volume-value {
  font-size: 12px;
  font-weight: 600;
  color: #333;
  min-width: 40px;
  text-align: right;
}

.agent-type-breakdown {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  margin-top: 10px;
}

.agent-type-tag {
  padding: 4px 8px;
  background: #e3f2fd;
  color: #1976d2;
  border-radius: 12px;
  font-size: 11px;
}

@media (max-width: 768px) {
  .stats-grid {
    grid-template-columns: 1fr;
  }

  .growth-bar {
    flex-direction: column;
    align-items: flex-start;
  }

  .bar-label {
    width: 100%;
    text-align: left;
  }

  .bar-wrapper {
    width: 100%;
  }

  .social-stats-grid {
    grid-template-columns: 1fr;
  }

  .pipeline-stats-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 480px) {
  .pipeline-stats-grid {
    grid-template-columns: 1fr;
  }
}

/* ── Section header with link ── */
.section-header-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.section-header-row h3 {
  margin: 0;
}

.section-link-btn {
  padding: 6px 14px;
  border: 1px solid #cbd5e1;
  border-radius: 6px;
  background: #fff;
  color: #1976d2;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.15s;
}

.section-link-btn:hover {
  background: #e3f2fd;
  border-color: #1976d2;
}

/* ── Social Connections Stats ── */
.social-stats-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
}

.social-stat-card {
  display: flex;
  align-items: center;
  gap: 14px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 18px;
  transition: box-shadow 0.15s;
}

.social-stat-card:hover {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.social-stat-icon {
  font-size: 1.8rem;
}

.social-stat-body {
  display: flex;
  flex-direction: column;
}

.social-stat-value {
  font-size: 1.6rem;
  font-weight: 700;
  color: #1e293b;
}

.social-stat-label {
  font-size: 0.78rem;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.03em;
}

.social-stat-active .social-stat-value {
  color: #16a34a;
}

.social-stat-expired .social-stat-value {
  color: #dc2626;
}

.social-platform-title {
  margin: 18px 0 8px 0;
  font-size: 0.95rem;
  font-weight: 600;
  color: #334155;
  letter-spacing: 0.01em;
}

.social-platform-title:first-of-type {
  margin-top: 0;
}

/* ── Pipeline Stats ── */
.pipeline-stats-grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 14px;
}

.pipeline-stat-card {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 16px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
}

.pipeline-stat-value {
  font-size: 1.7rem;
  font-weight: 700;
  color: #1e293b;
}

.pipeline-stat-label {
  font-size: 0.75rem;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.03em;
}

.pipeline-published .pipeline-stat-value {
  color: #16a34a;
}

.pipeline-active .pipeline-stat-value {
  color: #2563eb;
}

.pipeline-failed .pipeline-stat-value {
  color: #dc2626;
}

.pipeline-today .pipeline-stat-value {
  color: #7c3aed;
}

.pipeline-active-indicator {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-size: 0.7rem;
  font-weight: 600;
  color: #16a34a;
  text-transform: uppercase;
  margin-top: 2px;
}

.pipeline-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #16a34a;
  animation: pipeline-pulse 1.5s ease-in-out infinite;
}

@keyframes pipeline-pulse {

  0%,
  100% {
    opacity: 1;
  }

  50% {
    opacity: 0.4;
  }
}

/* Unresolvable orphans alert panel — superadmin-only. Shown only when the
   count is > 0 (no empty-state noise). Styled in amber to match the orphan
   badge on the user-facing post list. */
.unresolvable-orphans-panel {
  border: 1px solid rgba(245, 158, 11, 0.35);
  background: #fffbeb;
}

.unresolvable-orphans-panel .section-description {
  margin: 4px 0 0 0;
  color: #78350f;
  font-size: 14px;
}

.unresolvable-orphans-panel .orphan-badge-count {
  display: inline-block;
  margin-left: 8px;
  padding: 2px 8px;
  border-radius: 999px;
  background: #b91c1c;
  color: #fff;
  font-size: 13px;
  font-weight: 600;
  vertical-align: middle;
}

.unresolvable-orphans-table {
  margin-top: 12px;
  overflow-x: auto;
}

.unresolvable-orphans-table table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
}

.unresolvable-orphans-table th,
.unresolvable-orphans-table td {
  text-align: left;
  padding: 8px 10px;
  border-bottom: 1px solid #fde68a;
}

.unresolvable-orphans-table th {
  font-weight: 600;
  color: #78350f;
}`, "",{"version":3,"sources":["webpack://./src/admin/pages/Dashboard.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,wCAAwC;EACxC,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,oDAAoD;EACpD,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,wCAAwC;EACxC,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,eAAe;EACf,WAAW;AACb;;AAEA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA,mCAAmC;AACnC;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA,mCAAmC;AACnC;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,4BAA4B;AAC9B;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,mDAAmD;AACrD;;AAEA;;EAEE;;IAEE,UAAU;EACZ;;EAEA;IACE,YAAY;EACd;AACF;;AAEA;;wCAEwC;AACxC;EACE,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;AAEA;;EAEE,gBAAgB;EAChB,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB","sourcesContent":[".dashboard {\n  max-width: 1200px;\n}\n\n.dashboard-loading {\n  text-align: center;\n  padding: 40px;\n  color: #666;\n}\n\n.dashboard h2 {\n  margin: 0 0 20px 0;\n  color: #333;\n  font-size: 24px;\n}\n\n.stats-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 20px;\n  margin-bottom: 40px;\n}\n\n.dashboard-section {\n  background: white;\n  padding: 24px;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  margin-bottom: 30px;\n}\n\n.dashboard-section h3 {\n  margin: 0 0 20px 0;\n  color: #333;\n  font-size: 20px;\n}\n\n.period-selector {\n  display: flex;\n  gap: 10px;\n  margin-bottom: 20px;\n}\n\n.period-selector button {\n  padding: 8px 16px;\n  border: 1px solid #ddd;\n  background: white;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 14px;\n  transition: all 0.2s;\n}\n\n.period-selector button:focus {\n  outline: 2px solid #1976d2;\n  outline-offset: 2px;\n}\n\n.period-selector button:hover {\n  background: #f5f5f5;\n}\n\n.period-selector button.active {\n  background: #1976d2;\n  color: white;\n  border-color: #1976d2;\n}\n\n.chart-container {\n  min-height: 200px;\n}\n\n.growth-chart {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.growth-bar {\n  display: flex;\n  align-items: center;\n  gap: 15px;\n}\n\n.bar-label {\n  width: 100px;\n  font-size: 12px;\n  color: #666;\n  text-align: right;\n}\n\n.bar-wrapper {\n  flex: 1;\n  height: 24px;\n  background: #e0e0e0;\n  border-radius: 12px;\n  overflow: hidden;\n}\n\n.bar-fill {\n  height: 100%;\n  background: linear-gradient(90deg, #1976d2, #42a5f5);\n  transition: width 0.3s ease;\n}\n\n.bar-value {\n  width: 50px;\n  font-size: 14px;\n  font-weight: 600;\n  color: #333;\n  text-align: right;\n}\n\n.no-data {\n  text-align: center;\n  padding: 40px;\n  color: #999;\n}\n\n.whatsapp-stats {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 20px;\n}\n\n.whatsapp-stat-item {\n  text-align: center;\n  padding: 20px;\n  background: #f5f5f5;\n  border-radius: 8px;\n}\n\n.whatsapp-stat-item .stat-label {\n  font-size: 14px;\n  color: #666;\n  margin-bottom: 10px;\n}\n\n.stat-value-large {\n  font-size: 36px;\n  font-weight: 700;\n  color: #1976d2;\n}\n\n.analytics-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 20px;\n}\n\n.analytics-card {\n  background: #f5f5f5;\n  padding: 20px;\n  border-radius: 8px;\n  text-align: center;\n}\n\n.analytics-label {\n  font-size: 14px;\n  color: #666;\n  margin-bottom: 10px;\n}\n\n.analytics-value {\n  font-size: 24px;\n  font-weight: 700;\n  color: #1976d2;\n}\n\n.realtime-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 20px;\n}\n\n.realtime-card {\n  background: white;\n  padding: 20px;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  text-align: center;\n}\n\n.realtime-label {\n  font-size: 14px;\n  color: #666;\n  margin-bottom: 10px;\n}\n\n.realtime-value {\n  font-size: 32px;\n  font-weight: 700;\n  color: #1976d2;\n  margin-bottom: 5px;\n}\n\n.realtime-value.healthy {\n  color: #4caf50;\n}\n\n.realtime-value.degraded {\n  color: #ff9800;\n}\n\n.realtime-subtitle {\n  font-size: 12px;\n  color: #999;\n}\n\n.message-volume-chart {\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n}\n\n.message-volume-item {\n  padding: 15px;\n  background: #f5f5f5;\n  border-radius: 8px;\n}\n\n.volume-label {\n  font-size: 12px;\n  color: #666;\n  margin-bottom: 10px;\n}\n\n.volume-bars {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.volume-bar-wrapper {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.volume-bar-label {\n  width: 80px;\n  font-size: 12px;\n  color: #666;\n}\n\n.volume-bar-container {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  height: 20px;\n  position: relative;\n}\n\n.volume-bar {\n  height: 100%;\n  border-radius: 4px;\n  transition: width 0.3s ease;\n}\n\n.volume-bar.sent {\n  background: #1976d2;\n}\n\n.volume-bar.received {\n  background: #42a5f5;\n}\n\n.volume-value {\n  font-size: 12px;\n  font-weight: 600;\n  color: #333;\n  min-width: 40px;\n  text-align: right;\n}\n\n.agent-type-breakdown {\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n  margin-top: 10px;\n}\n\n.agent-type-tag {\n  padding: 4px 8px;\n  background: #e3f2fd;\n  color: #1976d2;\n  border-radius: 12px;\n  font-size: 11px;\n}\n\n@media (max-width: 768px) {\n  .stats-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .growth-bar {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .bar-label {\n    width: 100%;\n    text-align: left;\n  }\n\n  .bar-wrapper {\n    width: 100%;\n  }\n\n  .social-stats-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .pipeline-stats-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n@media (max-width: 480px) {\n  .pipeline-stats-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n/* ── Section header with link ── */\n.section-header-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n}\n\n.section-header-row h3 {\n  margin: 0;\n}\n\n.section-link-btn {\n  padding: 6px 14px;\n  border: 1px solid #cbd5e1;\n  border-radius: 6px;\n  background: #fff;\n  color: #1976d2;\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.15s;\n}\n\n.section-link-btn:hover {\n  background: #e3f2fd;\n  border-color: #1976d2;\n}\n\n/* ── Social Connections Stats ── */\n.social-stats-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 16px;\n}\n\n.social-stat-card {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  background: #f8fafc;\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n  padding: 18px;\n  transition: box-shadow 0.15s;\n}\n\n.social-stat-card:hover {\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n}\n\n.social-stat-icon {\n  font-size: 1.8rem;\n}\n\n.social-stat-body {\n  display: flex;\n  flex-direction: column;\n}\n\n.social-stat-value {\n  font-size: 1.6rem;\n  font-weight: 700;\n  color: #1e293b;\n}\n\n.social-stat-label {\n  font-size: 0.78rem;\n  color: #64748b;\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n}\n\n.social-stat-active .social-stat-value {\n  color: #16a34a;\n}\n\n.social-stat-expired .social-stat-value {\n  color: #dc2626;\n}\n\n.social-platform-title {\n  margin: 18px 0 8px 0;\n  font-size: 0.95rem;\n  font-weight: 600;\n  color: #334155;\n  letter-spacing: 0.01em;\n}\n\n.social-platform-title:first-of-type {\n  margin-top: 0;\n}\n\n/* ── Pipeline Stats ── */\n.pipeline-stats-grid {\n  display: grid;\n  grid-template-columns: repeat(5, 1fr);\n  gap: 14px;\n}\n\n.pipeline-stat-card {\n  background: #f8fafc;\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n  padding: 16px;\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 4px;\n}\n\n.pipeline-stat-value {\n  font-size: 1.7rem;\n  font-weight: 700;\n  color: #1e293b;\n}\n\n.pipeline-stat-label {\n  font-size: 0.75rem;\n  color: #64748b;\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n}\n\n.pipeline-published .pipeline-stat-value {\n  color: #16a34a;\n}\n\n.pipeline-active .pipeline-stat-value {\n  color: #2563eb;\n}\n\n.pipeline-failed .pipeline-stat-value {\n  color: #dc2626;\n}\n\n.pipeline-today .pipeline-stat-value {\n  color: #7c3aed;\n}\n\n.pipeline-active-indicator {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  font-size: 0.7rem;\n  font-weight: 600;\n  color: #16a34a;\n  text-transform: uppercase;\n  margin-top: 2px;\n}\n\n.pipeline-dot {\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  background: #16a34a;\n  animation: pipeline-pulse 1.5s ease-in-out infinite;\n}\n\n@keyframes pipeline-pulse {\n\n  0%,\n  100% {\n    opacity: 1;\n  }\n\n  50% {\n    opacity: 0.4;\n  }\n}\n\n/* Unresolvable orphans alert panel — superadmin-only. Shown only when the\n   count is > 0 (no empty-state noise). Styled in amber to match the orphan\n   badge on the user-facing post list. */\n.unresolvable-orphans-panel {\n  border: 1px solid rgba(245, 158, 11, 0.35);\n  background: #fffbeb;\n}\n\n.unresolvable-orphans-panel .section-description {\n  margin: 4px 0 0 0;\n  color: #78350f;\n  font-size: 14px;\n}\n\n.unresolvable-orphans-panel .orphan-badge-count {\n  display: inline-block;\n  margin-left: 8px;\n  padding: 2px 8px;\n  border-radius: 999px;\n  background: #b91c1c;\n  color: #fff;\n  font-size: 13px;\n  font-weight: 600;\n  vertical-align: middle;\n}\n\n.unresolvable-orphans-table {\n  margin-top: 12px;\n  overflow-x: auto;\n}\n\n.unresolvable-orphans-table table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 14px;\n}\n\n.unresolvable-orphans-table th,\n.unresolvable-orphans-table td {\n  text-align: left;\n  padding: 8px 10px;\n  border-bottom: 1px solid #fde68a;\n}\n\n.unresolvable-orphans-table th {\n  font-weight: 600;\n  color: #78350f;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
